import { getSuperVoiceList } from '@/service/generatorv2';
import { Button } from '@jenmusic/jen-ui-library';
import { useRequest } from 'ahooks';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useSuperVoiceList } from '../hooks';

export const Header = () => {
  const { superVoiceList } = useSuperVoiceList();
  const navigate = useNavigate();
  const isDisabled = superVoiceList.filter((item) => item.status === 'success').length === 0;
  return (
    <div className="py-6 px-6 flex justify-between items-center">
      <div className=" typography-jenmusic-display-medium">SuperVoice</div>
      <Button
        onClick={() => navigate('/super_voice/track_create')}
        className="gap-1 h-[52px] px-[18px] py-4 disabled:text-[#fff]"
        disabled={isDisabled}
      >
        <Plus width={16} />
        Create a SuperVoice Track
      </Button>
    </div>
  );
};
